export default class InterestsFormSerializer {
    static serialize(formData) {
        let   request = {};
        const portals = Object.keys(formData);

        portals.map(portal => {
            let selectedData = formData[portal];
            if(typeof selectedData[0] === 'object') {
                request[portal]  = selectedData.map(interest => interest.value);
            } else {
                request[portal]  = selectedData;
            }
        });

        return request;
    }

    static unserialize(response) {
        let formData = {};
        const interests = Object.values(response);

        interests.map(interest => {
            if(!formData[interest.portal.name]) {
                formData[interest.portal.name] = [];
            }

            formData[interest.portal.name].push(interest.interestId);
        });

        return formData;
    }
}


// WEBPACK FOOTER //
// ./web/src/services/InterestsFormSerializer.js